<template>
  <el-dialog
    :title="title"
    :visible="visible"
    width="50%"
    append-to-body
    @close="handleClose"
  >
    <el-form
      label-width="120px"
      :model="editForm"
      :disabled="true"
      ref="editForm"
    >
      <el-row>
        <el-form-item label="客户名称" prop="customerName">
          <el-input
            size="small"
            v-model="editForm.customerName"
            auto-complete="off"
            placeholder="客户名称"
            disabled
          ></el-input>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item label="业务员" prop="inSalesman">
          <el-input
            size="small"
            v-model="editForm.inSalesman"
            auto-complete="off"
            placeholder="请输入业务员"
          ></el-input>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item label="进价（%）" prop="inPercentage">
          <el-input-number
            :min="0"
            :max="100"
            size="small"
            :controls="false"
            v-model="editForm.inPercentage"
            placeholder="进价（%）"
          ></el-input-number>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item label="入库状态" prop="inStatus">
          <el-input
            size="small"
            v-model="editForm.inStatus"
            auto-complete="off"
            placeholder="请输入入库状态"
          ></el-input>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item label="报价员" prop="inBidder">
          <el-input
            size="small"
            v-model="editForm.inBidder"
            auto-complete="off"
            placeholder="请输入报价员"
          ></el-input>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item label="报价成本（%）" prop="inOffer">
          <el-input-number
            :min="0"
            :controls="false"
            size="small"
            v-model="editForm.inOffer"
            placeholder="报价成本（%）"
          ></el-input-number>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item label="应收（万）">
          <el-input-number
            :min="0"
            :controls="false"
            size="small"
            v-model="editForm.inArrears"
            placeholder="应收（万）"
          ></el-input-number>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item label="应付（万）">
          <el-input-number
            :min="0"
            :controls="false"
            size="small"
            v-model="editForm.outArrears"
            placeholder="应付（万）"
          ></el-input-number>
        </el-form-item>
      </el-row>
    </el-form>
  </el-dialog>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    editForm: {
      type: Object,
      default: () => ({}),
    },
    title: {
      type: String,
      default: "",
    },
  },
  methods: {
    handleClose() {
      this.$emit("update:visible", false);
      this.$refs.editForm.resetFields();
    },
    handlePayment() {
      this.$emit("confirm");
      this.handleClose();
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/views/ticket/ticket-offline/add-edit/detail.vue